import { SubText } from '@procurify/ui'
import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const AIRWALLEX_UK_TERMS_URL =
  'https://www.airwallex.com/uk/terms/acceptable-use-policy'

export interface ITermsAndConditionsFooterDisclaimerProps {}

export const TermsAndConditionsFooterDisclaimer =
  ({}: ITermsAndConditionsFooterDisclaimerProps) => {
    const intl = useProcurifyIntl()

    const { enable_airwallex_uk } = useSelector(makeSelectFeatureSwitches())

    return enable_airwallex_uk ? (
      <SubText className='terms-and-conditions-text' color='textSecondary'>
        {intl.formatMessage(messages.termsAndConditionsText, {
          a: (text) => (
            <a href={AIRWALLEX_UK_TERMS_URL} target='_blank' rel='noreferrer'>
              {text}
            </a>
          ),
        })}
      </SubText>
    ) : null
  }
